// extracted by mini-css-extract-plugin
module.exports = {"root":"Question_root__1bng4","question":"Question_question__1iawD","description":"Question_description__IzhUd"};